export interface SearchDData {
    clientId: string;
    url: string;
    renderInterval: number;
    portalMinPollInterval: number;
    searchDPollInterval: number;
    globalSearchTimeout: number;
    searchDPollIntervalMobile: number;
    globalSearchTimeoutMobile: number;
    s3MapDynamicRangeMinTriggerSearchTime: number;
    updatedHotelListThreshold: number;
    maxHotelListUpdateCount: number;
    s4SearchDPollInterval: number;
    autoVacancyPollTimeout: number;
    autoVacancyRenderInterval: number;
    s4StreamingGlobalTimeout: number;
    s4StreamingGlobalTimeoutAfterNoItems: number;
    s4StreamingRenderInterval: number;
    s4PriceCalendarInitialCallMobile: boolean;
    s4PriceCalendarLoadVisibleMobile: boolean;
    s5SearchDPollInterval: number;
    s5AutoVacancyPollTimeout: number;
    s5UpsellListPollTimeout: number;
}

let searchDData: SearchDData | null;

export function getSearchDData(): SearchDData | null {
    if (searchDData === undefined) {
        const searchDElement = document.getElementById(
            'js-searchd-information'
        );
        searchDData = searchDElement?.textContent
            ? (JSON.parse(searchDElement.textContent) as SearchDData)
            : null;
    }
    return searchDData;
}
